import { render, staticRenderFns } from "./poll.vue?vue&type=template&id=480913a5"
import script from "./poll.vue?vue&type=script&lang=js"
export * from "./poll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports